<button mat-raised-button *appRole="['TiposContratoQuienPaga.Crear']" (click)="openDialog('Agregar',{})" color="primary">
  <mat-icon>add</mat-icon>
  Nueva relacion Tipo Contrato - Quien Paga - Servicio
</button>
<br><br>
<mat-card *appRole="['TiposContratoQuienPaga.Ver']">
    <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>
    <mat-form-field class="example-full-width">
        <mat-label>Buscar</mat-label>
        <input matInput type="search" #search (keyup)="applyFilter($event)">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>&nbsp;

    <table mat-table [dataSource]="dataSource" [hidden]=!data matSort matSortStart="asc" class="mat-elevation-z8">

        <!--- Note mat-header-cellat mat-header-cellese columns can be defined in any order.
        mat-header-celle actual rendered columns are set as a property on mat-header-celle row definition" -->


        <!-- Tipo Contrato -->
        <ng-container matColumnDef="tipoContrato">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Tipo Contrato</mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element">{{element.tipoContrato}} </mat-cell>
        </ng-container>

        <!-- Quien Paga -->
        <ng-container matColumnDef="quienPaga">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Quien Paga</mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element">{{element.quienPaga}} </mat-cell>
        </ng-container>

        <!-- Servicio -->
        <ng-container matColumnDef="servicio">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Servicio</mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element">{{element.servicio}} </mat-cell>
        </ng-container>

        <!-- Servicio -->
        <ng-container matColumnDef="descripcion">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Descripción</mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element">{{element.descripcion}} </mat-cell>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="accion">
            <mat-header-cell mat-header-cell *matHeaderCellDef> Acción</mat-header-cell>
            <mat-cell mat-cell *matCellDef="let element" class="action-link">

              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item *appRole="['TiposContratoQuienPaga.Modificar']" (click)="openDialog('Modificar',element)">
                      <mat-icon>edit</mat-icon>
                      <span>Editar</span>
                    </button>
                        <button mat-menu-item *appRole="['TiposContratoQuienPaga.Modificar']" (click)="openDialog('Eliminar',element) ">
                      <mat-icon>delete</mat-icon>
                      <span>Eliminar</span>
                    </button>
                  </mat-menu>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </table>
    <app-sin-datos></app-sin-datos>
    <mat-paginator showFirstLastButtons class="paginator" [hidden]=!data [pageSize]="10" [pageSizeOptions]="[5, 10, 20,50,100,200]">
    </mat-paginator>
</mat-card>
